<template>
  <div id="PageTemplate">

    <!-- LIST -->
    <div class="list-section" :class="{hide: $route.query.details}">
      <vo-list-header class="header" :page="page"></vo-list-header>
      <vo-list class="list-item" selectable :selected="page.selected" :list="page.list" :itemComponent="listComponent" @itemSelected="openListItem" lazy></vo-list>

      <v-btn v-if="page.fab && checkFab(page.fab.permissions)" color="accent" class="fab" fab @click="fabClicked">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>

    <!-- PAGE -->
    <component class="page" :class="{active: $route.query.details, 'has-drawer': drawerComponent}" :page="page" :is="pageComponent"></component>

    <!-- FILTER SCRIM -->
    <div class="vo-scrim" :class="{active: $route.query.filter}" @click="routeRemoveQuery('filter')"></div>

    <!-- FILTER -->
    <div class="filter" :class="{active: $route.query.filter}">
      <template v-if="page.filterComponent.cmp === 'vo-filter'">
        <vo-filter :filtering="page.filtering"></vo-filter>
      </template>
      <template v-else-if="page.filterComponent.cmp === 'vo-filter-nav'">
        <vo-filter-nav :links="page.filterComponent.params.links" :navElement="page.filterComponent.params.navElement"></vo-filter-nav>
      </template>
    </div>

    <!-- DRAWER SCRIM -->
    <div class="vo-scrim drawer-scrim" :class="{active: $route.query[drawerQuery]}" @click="$router.go(-1)"></div>

    <!-- DRAWER COMPONENT -->
    <div v-if="drawerComponent" class="drawer" :class="{active: $route.query[drawerQuery]}">
      <component :page="page" :is="drawerComponent"></component>
    </div>

  </div>
</template>

<script>

  import permissionMixin from '../mixins/permissionMixin.js'

  export default {
    mixins: [permissionMixin],
    data () {
      return {

      }
    },
    props: {
      listComponent: {
        required: true
      },
      pageComponent: {
        required: true
      },
      pageKey: {
        required: true
      },
      drawerComponent: {
     
      },
      drawerQuery: {

      }
    },

    methods: {
      
      openListItem (item) {
        this.routeAddQuery('details', item);
      },
      
      fabClicked () {
        this.routeAddQuery('dialog', this.page.fab.click);
      },

      checkFab (perms) {
        if (!perms) return true;
        else {
          return this.hasPermissions(perms);
        }
      }
    
    },

    computed: {
      page () {
        return this.app.pages[this.pageKey];
      }
    },

    created () {

      if (!this.hasPermissions(this.page.permissions)) {
        this.reroute(true);
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #PageTemplate {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: $white;

    .filter {
      position: fixed;
      top: 64px;
      left: 0;
      bottom: 0;   
      max-width: 280px;
      width: 100%;
      transform: translate3d(0, 0, 0);
      overflow: hidden;

      transition: all .3s ease;
    }

    .vo-scrim {
      &.drawer-scrim {
        display: none;
      }
    }
  
    .list-section {
      position: absolute;
      top: 0;
      left: 280px;
      bottom: 0;
      width: 100%;
      max-width: 360px;

      transition: all .3s ease;      
    
      .fab {
        position: absolute;
        bottom: 16px;
        right: 16px;
        color: rgba(0, 0, 0, .87);
      }

      .header {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 48px;
      }

      .list-item {
        @include scrollable();
      
        position: absolute;
        top: 48px;
        left: 0;
        right: 0;
        bottom: 0;
        border-top: 1px solid $black12;
      }
    }
  
    .page {
      @include scrollable();

      position: absolute;
      top: 0;
      left: 640px;
      right: 0;
      bottom: 0;
      border-left: 1px solid $black12;

      transition: all .3s ease;

      &.has-drawer {
        right: 360px;
      }
    }

    .drawer {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 360px;
      border-left: $borderBlack12;
      transition: all .3s ease;      
    }

    // Hide drawer by default
    @media screen and (max-width: 1480px) {
     
      .page {
        &.has-drawer {
          right: 0;
        }
      }

      .vo-scrim {
        &.drawer-scrim {
          display: block;
        }
      }

      .drawer {
        transform: translate3d(100%, 0, 0);
        pointer-events: none;

        &.active {
          transform: translate3d(0, 0, 0);          
          pointer-events: auto;
        }
      }
    }


    // Hide filter by default
    @media screen and (max-width: 1000px) {

      .filter {
        transform: translate3d(-100%, 0, 0);
        pointer-events: none;
        
        &.active {
          transform: translate3d(0, 0, 0);      
          pointer-events: auto;
        }
      }

      .list-section {
        left: 0 !important;
      }

      .page {
        left: 360px !important;
      }

    }

    @media screen and (max-width: 880px) {
      .filter {
        top: 60px;
      }
    }

    // Hide pageComponent by default
    @media screen and (max-width: 768px) {

      .list-section {
        right: 0 !important;
        width: 100% !important;
        max-width: 100% !important;

        &.hide {
          pointer-events: none;
          transform: translate3d(-100%, 0, 0);
        }
      }

      .page {
        left: 0 !important;
        transform: translate3d(100%, 0, 0);
        pointer-events: none;

        &.active {
          pointer-events: auto;
          transform: translate3d(0, 0, 0);          
        }
      }

    }

    @media screen and (max-width: 600px) {

      .drawer {
        &.active {
          width: 100%;
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/PageTemplate.vue